import _ from 'underscore';
import Backbone from 'backbone';
import Loadable from 'utils/extensions/Loadable';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';

import templateHtml from 'embed/templates/EmbedContainer.html';

var LoadableView = Backbone.View.extend(Loadable);

export default LoadableView.extend({
    initialize: function(args) {
        this.userPreferences = args.userPreferences;
        this.pageView = null;
        this.registeredApplicationEvents = {}; // List of application events that have been registered

        this.template = _.template(templateHtml);
    },

    render: function() {
        if (this.pageView && this.pageView.isLoaded()) {
            this.$el.empty();
            this.$el.removeClass();
            this.$el.addClass('embed-container');
            this.$el.addClass(this.pageView.pageClassName);

            if (this.pageView.args?.pageClassName) {
                this.$el.addClass(this.pageView.args.pageClassName);
            }

            this.$el.html(this.template({}));

            let userLocale = ViewerUserPreferences.get('preferredLocale');
            jQuery('html').attr('lang', userLocale);

            var $pageContainer = this.$('#embedContainer');
            $pageContainer.append(this.pageView.el);

            window.scrollTo(0, 0);

            this.pageView.render();

            jQuery('body').removeClass('wait');
        }
    },

    /**
     * Sets the page view that will be rendered in the PageContainer.
     * @param pageView the PageView to display. May be null.
     */
    setPageView: function(pageView) {
        if (this.pageView) {
            this.pageView.onPageUnloaded();
        }

        this.pageView = pageView;

        if (this.pageView) {
            if (this.pageView.isLoaded()) {
                this.render();
            } else {
                this.pageView.once(
                    pageView.Loadable.Events.ON_DEPENDENCIES_LOADED,
                    this.onPageDependenciesLoaded,
                    this
                );
            }
        }
    },

    /**
     * Called when the child pages dependencies have been loaded, meaning its okay to render.
     */
    onPageDependenciesLoaded: function() {
        this.render();
    },

    /**
     * Dynamically applies the given css text.
     * @param css contents to inject into the DOM.
     */
    setApplicationCss: function(css) {
        $("<style type='text/css'>" + css + '</style>').appendTo('head');
    },

    /**
     * Called when the page container has been unloaded. Performs cleanup.
     */
    onContainerUnloaded: function() {
        if (this.pageView) {
            this.pageView.onPageUnloaded();
            this.off();
            this.stopListening();
        }
    }
});
